import React from 'react';

import classnames from "classnames";
import styles from "../styles/game-info-module.module.scss";
import {SVGImage} from "../../../../../core/components/image/svg-image";
import {Tooltip} from "../../../../../core/components/tooltip/tooltip";

export const GameInfoModuleItem = ({item, controller}) => {
  const {navigationManager} = controller;

  const {icon, url, title, subtitle, tooltipDescription} = item;

  const iconProps = {
    onClick: () => url && navigationManager.gotoUrl(url?.toString(), false, true),
    src: icon
  }

  const tooltipProps = {
    content: url ? tooltipDescription : null,
    className: classnames(styles.icon, {[styles.clickable]: url}),
  }

  return (
    <div className={classnames(styles.item, {[styles.without_subtitle]: !subtitle})}>
      <Tooltip {...tooltipProps} >
        <SVGImage {...iconProps} />
      </Tooltip>
      <div className={classnames(styles.title)}>
        {title}
      </div>
      <div className={classnames(styles.subtitle)}>
        {subtitle}
      </div>
    </div>
  )
};
